module.exports = __webpack_public_path__ + "img/myh3.c0e4c44e.jpg";